import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Restricted from "src/app/Restricted";
import PATHS, { url } from "src/consts/urlPaths";

const SummaryLink = ({ children, item, className }) => (
  <Restricted>
    <Link
      id="summary-nav-link"
      to={url(PATHS.INSIGHTS)}
      aria-label={item.name}
      className={className}
    >
      {children}
    </Link>
  </Restricted>
);

SummaryLink.propTypes = {
  item: PropTypes.object,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default SummaryLink;
